// src/Settings/DatabaseAdvisor/utils.js
import { SEVERITY_ORDER } from './constants';

export const getTableStatusSeverity = table => {
  if (!table.exists) return 'critical';
  const severities = table.findings.map(finding => finding.severity);
  return SEVERITY_ORDER.find(severity => severities.includes(severity)) || null;
};

export const getRowStatus = table => {
  if (!table.exists) return 'missing';
  const severity = getTableStatusSeverity(table);
  return severity || 'healthy';
};

export const filterTables = (tables, filter) => {
  if (filter === 'missing') return tables.filter(table => !table.exists);
  if (filter === 'issues')
    return tables.filter(table => !table.exists || table.findings.length > 0);
  return tables;
};

// CLIENT BRANCH: index findings are only ever "declared on the model but not found in the
// database" — there is no "extra" (found in the database, not declared) direction here.
export const getIndexFindingStatus = item => (item.exists ? 'present' : 'missing');

export const filterIndexFindings = (indexFindings, filter) => {
  if (filter === 'missing') return indexFindings.filter(item => !item.exists);
  return indexFindings;
};

// CLIENT BRANCH: same rule as index findings above -- only ever "declared on the model but not
// found in the database".
export const getFkFindingStatus = item => (item.exists ? 'present' : 'missing');

export const filterFkFindings = (fkFindings, filter) => {
  if (filter === 'missing') return fkFindings.filter(item => !item.exists);
  return fkFindings;
};

export const searchFkFindings = (fkFindings, query) => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return fkFindings;
  return fkFindings.filter(
    item =>
      item.column.toLowerCase().includes(normalizedQuery) ||
      item.tableName.toLowerCase().includes(normalizedQuery) ||
      (item.referencedTable || '').toLowerCase().includes(normalizedQuery)
  );
};

export const searchTables = (tables, query) => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return tables;
  return tables.filter(
    table =>
      table.tableName.toLowerCase().includes(normalizedQuery) ||
      table.modelName.toLowerCase().includes(normalizedQuery)
  );
};

export const searchIndexFindings = (indexFindings, query) => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return indexFindings;
  return indexFindings.filter(
    item =>
      item.name.toLowerCase().includes(normalizedQuery) ||
      item.tableName.toLowerCase().includes(normalizedQuery)
  );
};

export const formatCardSubtitle = table => {
  if (!table.exists) return 'Not found in database';
  const rowLabel = table.rowCount == null ? '— rows' : `${table.rowCount.toLocaleString()} rows`;
  const issueLabel = `${table.findings.length} issue${table.findings.length !== 1 ? 's' : ''}`;
  return `${rowLabel} · ${issueLabel}`;
};

export const pillStyle = color => ({
  padding: '3px 10px',
  borderRadius: 5,
  fontSize: 11,
  fontWeight: 700,
  background: `${color}18`,
  border: `1px solid ${color}44`,
  color,
  display: 'inline-block',
});
